// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_76-0";
export var optionCard = "_76-1";